var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<span class="display-block">\n  <span class="font-semibold" id="mobile-sentence-dp-percent"></span>\nDown Payment \n</span>\n<span class="font-semibold" id="mobile-sentence-loan-type"></span> \nLoan at\n<span class="font-semibold" id="mobile-sentence-mrtg-percent"></span>  \n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/mobile-sentence.jst.ejs